import { render, staticRenderFns } from "./docTable.vue?vue&type=template&id=7b9ac8fc&scoped=true&"
import script from "./docTable.vue?vue&type=script&lang=js&"
export * from "./docTable.vue?vue&type=script&lang=js&"
import style0 from "./docTable.vue?vue&type=style&index=0&id=7b9ac8fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9ac8fc",
  null
  
)

export default component.exports